import React from 'react'
import context from '@/context'
import { Row, Col, Label, Input } from 'reactstrap'
import { WhiteBox } from '@/components/Layout'
import { Button } from '@/components/button'
import Resx from '@/components/Resx'
import { validate } from './validation/index'
import { localized } from '@/decorators/localized'
import { allowErrorDialog } from '@/utils/fetch'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'

const isAnyEmpty = (datasets) => {
  const emptyDatasets = datasets.filter(x => x.reportSubmissionGroups.length === 0)

  // When there are no datasets, whether they are empty is not relevant
  return datasets.length > 0 && emptyDatasets.length > 0
}
@localized()
class GenerateBox extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: false,
      name: props.outputDefinition.name,
      latinName: props.outputDefinition.latinName
    }
  }
  componentDidMount () {
    const { name, latinName } = this.props.outputDefinition
    this.setState({ name, latinName })
  }
  onGenerate = () => {
    const { datasets, outputDefinition } = this.props
    const { name, latinName } = this.state

    this.setState({ isLoading: true }, () => {
      context.api.outputReportGroupService.generate({ definitionId: outputDefinition.id, datasets, name, latinName }, allowErrorDialog)
        .then(() => {
          this.setState({ isLoading: false })
          if (typeof this.props.onGenerate === 'function') { this.props.onGenerate() }
        })
        .catch(() => this.setState({ isLoading: false }))
    })
  }
  render () {
    const { datasets, outputDefinition, localize, locale } = this.props
    const { isLoading, name, latinName } = this.state
    const isDatasetEmpty = isAnyEmpty(datasets)
    const validationResults = validate(datasets, outputDefinition.multipleInstitutions, localize, locale)
    const isDisabled = isDatasetEmpty || isLoading || validationResults.length > 0
    return (
      <ValidationBoundary>
        <WhiteBox>
          <Row>
            <Col>
              <Label><Resx name='Common.Name' /></Label>
              <Validator name='name' value={name} required>
                <Input value={name} onChange={e => this.setState({ name: e.target.value })} />
              </Validator>
            </Col>
          </Row>
          <Row>
            <Col>
              <Label><Resx name='Common.LatinName' /></Label>
              <Validator name='latinName' value={latinName} required>
                <Input value={latinName} onChange={e => this.setState({ latinName: e.target.value })} />
              </Validator>
            </Col>
          </Row>
          <Row>
            <Col>
              <ValidationState render={({ isValid }) =>
                <Button icon={isLoading ? 'loader bx-spin' : 'save'} color='primary' disabled={isDisabled || !isValid} onClick={this.onGenerate}><Resx name='Common.Generate' /></Button>
              } />
            </Col>
          </Row>
          {validationResults.length > 0 && <ul className='validation-results'>{validationResults.map((x, idx) => <li key={idx}>{x}</li>)}</ul>}
        </WhiteBox>
      </ValidationBoundary>
    )
  }
}

export {
  GenerateBox
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/generateBox.js